import {
  Directive,
  EventEmitter,
  HostListener,
  Injector,
  Output,
} from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { DialogContainerComponent } from '@libs/shared/ui/dialog-container/dialog-container.component';
import { ElasticsearchTermAnalyzerComponent } from '@libs/shared/ui/elasticsearch-term-analyzer/elasticsearch-term-analyzer.component';

@Directive({
  selector: '[appElasticsearchTermAnalyzerDialogTrigger]',
  standalone: true,
})
export class ElasticsearchTermAnalyzerDialogTriggerDirective {
  @Output() dialogClosed = new EventEmitter<any>();

  constructor(
    private dialog: MatDialog,
    private injector: Injector
  ) {}

  @HostListener('click', ['$event'])
  public onClick(event: Event): void {
    event.preventDefault();
    const dialogRef = this.dialog.open(DialogContainerComponent, {
      minWidth: '600px',
      panelClass: 'custom-dialog-container',
      data: {
        title: 'Elasticsearch Term Analyzer',
        component: ElasticsearchTermAnalyzerComponent,
        injector: this.injector,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.dialogClosed.emit(result);
    });
  }
}
